import { useEffect } from "react";
import { useLocation } from "react-router";

export const ScrollBehavior = {
	Scroll: "scroll",
	NoScroll: "noscroll",
};

export const ScrollToTop: React.FC = () => {
	const { pathname, search, state } = useLocation();
	useEffect(() => {
		if (state !== ScrollBehavior.NoScroll) {
			window.scrollTo(0, 0);
		}
	}, [pathname]);

	useEffect(() => {
		if (state === ScrollBehavior.Scroll) {
			window.scrollTo(0, 0);
		}
	}, [search]);

	return null;
};
